<template>
  <div
    id="channelAdvisor"
    class="channel-advisor"
    :class="[hasButtons ? 'mb-md' : '']"
    :data-variantid="currentVariantId"
  >
    <slot />
    <vch-modal
      :open="buyOnlineModalOpen"
      @closed="closeBuyModal"
      :closeAriaLabel="closeAriaLabel"
      :busName="busNameBuyOnline"
    >
      <slot name="retailer-list" />
    </vch-modal>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName as variantSelectorBus } from 'Directives/variant-selector/variant-selector';

export default {
  name: 'vch-channel-advisor',
  props: {
    closeAriaLabel: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      busNameBuyOnline: 'channel-advisor-buy-modal',
      buyOnlineModalOpen: false,
      currentVariantId: null,
    };
  },
  computed: {
    hasButtons() {
      return this.$slots.default;
    },
  },
  mounted() {
    eventBus.$on(`${this.busNameBuyOnline}:open`, this.openBuyModal);
    eventBus.$on(`${variantSelectorBus}::selected`, this.updateVariantID);
    this.eRetailerUnavailableOnLoad();
  },
  methods: {
    closeBuyModal() {
      this.buyOnlineModalOpen = false;
    },
    openBuyModal() {
      this.buyOnlineModalOpen = true;
    },
    updateVariantID(variantEAN) {
      this.currentVariantId = variantEAN;
    },
    eRetailerUnavailableOnLoad() {
      const select = (selector) => document.querySelector(selector);
      const buyBtn = select('.vch-pdp-grid__content .button.-primary.buy-btn');
      const channelAdvisor = select('.channel-advisor-content');
      const retailerInfo = select(
        '.vch-pdp-grid__content .eretailer-unavailable'
      );
      const channelAdvisorWrapper = select('.channel-advisor');
      const ccModal = select('.cc-modal');
      if (!ccModal) {
        if (!channelAdvisor) {
          buyBtn?.classList.add('hideBtn');
          retailerInfo?.classList.remove('hideInfo');
          !retailerInfo
            ? channelAdvisorWrapper.classList.remove('mb-md')
            : channelAdvisorWrapper.classList.add('mb-md');
        } else {
          retailerInfo?.classList.add('hideInfo');
          buyBtn?.classList.remove('hideBtn');
          !buyBtn
            ? channelAdvisorWrapper.classList.remove('mb-md')
            : channelAdvisorWrapper.classList.add('mb-md');
        }
      }
    },
  },
};
</script>
<style lang="scss" src="./channel-advisor.scss"></style>
